<template>
  <div>
    <div class="report-item-question-title">
      {{ question.q }}
    </div>
    <div class="report-item-detail-box">
      <div class="report-item-detail-chart">
        <div v-if="question.q_type === 'Options'">
          <bars-chart :chartData="question.q_data"> </bars-chart>
        </div>
        <div v-if="question.q_type === 'Age'">
          <bars-chart :chartData="question.q_data"> </bars-chart>
        </div>
        <div v-if="question.q_type === 'NPS'">
          <bars-chart :chartData="question.q_data"> </bars-chart>
        </div>
        <div v-if="question.q_type === 'NPSTigo'">
          <bars-chart :chartData="question.q_data"> </bars-chart>
        </div>
        <div v-if="question.q_type === 'NPSBA'">
          <bars-chart :chartData="question.q_data"> </bars-chart>
        </div>
        <div v-if="question.q_type === 'MultipleOptions'">
          <bars-chart :chartData="question.q_data"> </bars-chart>
        </div>
        <div v-if="question.q_type === 'DPI'">
          <bars-chart :chartData="question.q_data"> </bars-chart>
        </div>
        <div v-if="question.q_type === 'NPSBA'">
          <bars-chart :chartData="question.q_data"> </bars-chart>
        </div>
        <div v-if="question.q_type === 'Range'">
          <bars-chart :chartData="question.q_data"> </bars-chart>
        </div>
        <div v-if="question.q_type === 'IMEI'">
          <bars-chart :chartData="question.q_data"> </bars-chart>
        </div>
        <div v-if="question.q_type === 'DPI'">
          <bars-chart :chartData="question.q_data"> </bars-chart>
        </div>
        <div v-if="question.q_type === 'PhoneNumber'">
          <bars-chart :chartData="question.q_data"> </bars-chart>
        </div>
        <div v-if="question.q_type === 'Gender'">
          <pie-chart :chartData="question.q_data"> </pie-chart>
        </div>
        <div v-if="question.q_type === 'Yes/No'">
          <pie-chart :chartData="question.q_data"> </pie-chart>
        </div>
        <div v-if="question.q_type === 'State'">
          <pie-chart :chartData="question.q_data"> </pie-chart>
        </div>
      </div>
      <div v-if="question.q_type != 'Open'" class="report-item-detail-table">
        <table-question :chartData="question.q_data_table"> </table-question>
      </div>
    </div>

    <div v-if="question.q_type === 'Open'"
      class="report-item-detail-box wordcloud-styles">
      <div class="report-item-detail-chart wordcloud-styles-fullwidth">
        <div v-if="question.q_type === 'Open'">
          <word-cloud :chartData="question.q_data"> </word-cloud>
        </div>
      </div>
      <div class="show-results-btn" v-on:click="isHidden = !isHidden">Mostrar Lista de resultados</div>
      <div v-if="isHidden" class="report-item-detail-table wordcloud-styles-fullwidth">
        <table-question :chartData="question.q_data_table"> </table-question>
      </div>
    </div>
  </div>
</template>

<script>
import BarsChart from "@/views/Surveys/bars-chart.vue";
import PieChart from "@/views/Surveys/pie-chart.vue";
import WordCloud from "@/views/Surveys/word-cloud.vue";
import TableQuestion from "@/views/Surveys/tableQuestion.vue";
export default {
  name: "Question",
  components: { BarsChart, PieChart, WordCloud, TableQuestion },
  props: {
    question: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data () {
    return {
      isHidden: false

    };
  }
};
</script>
